import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceCategorySelector = ({ selectedCategory, onCategorySelect, categories }) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-foreground mb-2">Select Service Category</h2>
        <p className="text-muted-foreground">Choose the type of ICT solution you need</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategorySelect(category)}
            className={`p-6 rounded-lg border-2 transition-all duration-200 text-left hover:shadow-moderate ${
              selectedCategory?.id === category?.id
                ? 'border-primary bg-primary/5 shadow-moderate'
                : 'border-border hover:border-primary/50'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div className={`p-3 rounded-lg ${
                selectedCategory?.id === category?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                <Icon name={category?.icon} size={24} />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-2">{category?.name}</h3>
                <p className="text-sm text-muted-foreground mb-3">{category?.description}</p>
                <div className="flex flex-wrap gap-1">
                  {category?.tags?.slice(0, 3)?.map((tag, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs bg-muted text-muted-foreground rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                  {category?.tags?.length > 3 && (
                    <span className="px-2 py-1 text-xs text-muted-foreground">
                      +{category?.tags?.length - 3} more
                    </span>
                  )}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ServiceCategorySelector;